import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';
import { useToast } from 'vue-toastification';

const company = computed(() => store.getters['company/info']);
const toast = useToast();

export default {
	index(params) {
		return Repository.get(`/company/${company.value.id}/admin/goal`, { params: params });
	},
	store(payload) {
		return Repository.post(`/company/${company.value.id}/admin/goal`, payload).then((response) => {
			toast.success(`Meta creada correctamente.`);
			return response;
		});
	},
	copy(id) {
		return Repository.get(`/company/${company.value.id}/admin/goal/copy`);
	},
	show(id) {
		return Repository.get(`/company/${company.value.id}/admin/goal/${id}`);
	},
	update(id, payload) {
		return Repository.put(`/company/${company.value.id}/admin/goal/${id}`, payload).then((response) => {
			toast.success(`Meta actualizada correctamente.`);
			return response;
		});
	},
	destroy(id) {
		return Repository.delete(`/company/${company.value.id}/admin/goal/${id}`).then((response) => {
			toast.success(`Meta eliminada correctamente.`);
			return response;
		});
	},
	stat(id) {
		return Repository.get(`/company/${company.value.id}/admin/goal/${id}/stat`);
	}
}